import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/codepen': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M502.3 159.7L268.3 3.7C260.3-1.2 251.8-1.3 243.7 3.7L9.7 159.7C3.7 163.7 0 170.8 0 178V334C0 341.1 3.7 348.3 9.7 352.3L243.7 508.3C251.7 513.2 260.2 513.3 268.3 508.3L502.3 352.3C508.3 348.3 512 341.1 512 334V178C512 170.8 508.3 163.7 502.3 159.7zM278 63.1L450.3 178 373.4 229.4 278 165.7V63.1zM234 63.1V165.7L138.6 229.4 61.7 178 234 63.1zM44 219.1L99.1 256 44 292.8V219.1zM234 448.8L61.7 334 138.6 282.6 234 346.3V448.8zM256 308L178.3 256 256 204 333.7 256 256 308zM278 448.8V346.3L373.4 282.6 450.3 334 278 448.8zM468 292.8L412.9 256 468 219.1V292.8z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/codepen.js
// module id = no2u
// module chunks = 144